// extracted by mini-css-extract-plugin
export var dividerLine = "_59-0";
export var errorBackground = "_59-1";